import {
	connect
} from 'react-redux'
import OrderDetailEditComponent from '../components/OrderDetailEditComponent.jsx';
import {
	changeOrderDetailValue,
	addOrderDetail,
	editOrderDetail,
	findAllGears,
	findGearSpecIdsByGearName,
	changeShowSpecIdHasLabel
} from '../actions';

const mapStateToProps = (state) => ({
	orderDetail: state.getIn(['orderReducer', 'orderDetail']),
	orderDetailValidation: state.getIn(['orderReducer', 'orderDetailValidation']),
	allGears: state.getIn(['commonReducer', 'allGears']),
	alertStyle: state.getIn(['orderReducer', 'alertStyle']),
	alertMessage: state.getIn(['orderReducer', 'alertMessage']),
	forInsert: state.getIn(['orderReducer', 'forInsert']),
	specIds: state.getIn(['orderReducer', 'specIds']),
	showSpecIdHasLabel: state.getIn(['orderReducer', 'showSpecIdHasLabel']),
	showSpecIdNoLabel: state.getIn(['orderReducer', 'showSpecIdNoLabel']),
})

const mapDispatchToProps = (dispatch) => ({
	editOrderDetail: (orderDetail, forInsert) => {
		if (forInsert) {
			dispatch(addOrderDetail(orderDetail));
		} else {
			dispatch(editOrderDetail(orderDetail));
		}
	},
	setValue: (id, value) => {
		dispatch(changeOrderDetailValue({
			id: id,
			value: value
		}))
	},
	findAllGears: () => {
		dispatch(findAllGears());
	},
	findGearSpecIdsByGearName: (pk) => {
		dispatch(findGearSpecIdsByGearName(pk));
	},
	changeShowSpecIdHasLabel: (payload) => {
		dispatch(changeShowSpecIdHasLabel(payload));
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	orderDetail: stateProps.orderDetail,
	orderDetailValidation: stateProps.orderDetailValidation,
	allGears: stateProps.allGears,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	forInsert: stateProps.forInsert,
	specIds: stateProps.specIds,
	showSpecIdHasLabel: stateProps.showSpecIdHasLabel,
	showSpecIdNoLabel: stateProps.showSpecIdNoLabel,
	findAllGears: dispatchProps.findAllGears,
	findGearSpecIdsByGearName: dispatchProps.findGearSpecIdsByGearName,
	changeShowSpecIdHasLabel: dispatchProps.changeShowSpecIdHasLabel,
	editOrderDetail: () => dispatchProps.editOrderDetail(stateProps.orderDetail, stateProps.forInsert),
	setValue: dispatchProps.setValue
})

const OrderDetailEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(OrderDetailEditComponent)

export default OrderDetailEditContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderDetailEditContainer.jsx